import request from '@/utils/request'
import onlyNasFileUploadUseRequest from '@/utils/onlyNasFileUploadUseRequest'

export function getGradeintegral () {
  return request({
    url: '/api/tutorcomm/Gradeintegral',
    method: 'post'
  })
}
export function getProfile () {
  return request({
    url: '/api/tutordata/Profile',
    method: 'post'
  })
}
export function getLocations () {
  return request({
    url: '/api/tutorinfo/Locations',
    method: 'post'
  })
}
export function getSchools () {
  return request({
    url: '/api/tutorinfo/Schools',
    method: 'post'
  })
}
// TeachComplaint
export function getTeachComplaint (pageIndex, pageSize) {
  return request({
    url: '/api/tutordata/TeachComplaint',
    method: 'post',
    data: {
      pageIndex,
      pageSize
    }
  })
}
// ComplaintReply
export function getComplaintReply (id) {
  return request({
    url: '/api/tutordata/ComplaintReply?comId=' + id,
    method: 'post'
  })
}
// AddComReply
export function addComReply (comId, content) {
  return request({
    url: '/api/tutordata/AddComReply',
    method: 'post',
    data: {
      comId,
      content
    }
  })
}

// InsertTeachComplaint
export function insertTeachComplaint (formData) {
  return request({
    url: '/api/tutordata/InsertTeachComplaint',
    method: 'post',
    data: formData
  })
}

// CSComplaints
export function getCSComplaints (pageIndex, pageSize) {
  return request({
    url: '/api/tutordata/CSComplaints?pageIndex=' + pageIndex + '&pageSize=' + pageSize,
    method: 'post'
  })
}
// CSComplaintsNew
export function getCSComplaintsNew (pageIndex, pageSize) {
  return request({
    url: '/api/TutorData/GetCSComplaintsNew?pageIndex=' + pageIndex + '&pageSize=' + pageSize,
    method: 'post'
  })
}
// 获取迟到早退列表
export function getTeacherLateLeaveEarlyRecord (param) {
  return request({
    url: '/api/TutorData/TeacherLateLeaveEarlyRecord',
    method: 'Post',
    timeout: 5 * 60 * 1000 * 1000,
    data: param
  })
}

// TrainingKits
export function getTrainingKits () {
  return request({
    url: '/api/tutordata/TrainingKits',
    method: 'post'
  })
}

// TrainingKitModel
export function getTrainingKitModel (primaryID) {
  return request({
    url: '/api/tutordata/TrainingKitModel?primaryID=' + primaryID,
    method: 'post'
  })
}

// KCTList
export function getKCTList (kctId) {
  return request({
    url: '/api/tutordata/KCTList?kctId=' + kctId,
    method: 'post'
  })
}

// Dashboard老师课时及评价
export function getTutorClassInfo () {
  return request({
    url: '/api/tutordata/TutorClassInfo',
    method: 'post'
  })
}

// 转化课时数
export function getTutorTrail (tuid) {
  return request({
    url: '/api/tutordata/GetTutorTrail',
    method: 'post',
    data: {
      tuid
    }
  })
}

// 是否是TT实验组老师
export function isTuTopTestGroup () {
  return request({
    url: '/api/tutordata/IsTuTopTestGroup',
    method: 'post'
  })
}
// 首页榜单
export function getTuTopTutorRank () {
  return request({
    url: '/api/tutordata/GetTuTopTutorRank',
    method: 'post'
  })
}

// 新的首页榜单， 判断是否显示及详情数据 
export function getRankingSummary () {
  return request({
    url: '/api/tutordata/GetRankingSummary',
    method: 'post'
  })
}

// 成功接单排行榜
export function GetDidiReceivedRankingList(pageIndex,pageSize) {
  return request({
    url: '/api/tutordata/GetDidiReceivedRankingList?pageIndex='+pageIndex+"&pageSize="+pageSize,
    method: 'post'
  })
}

// 接单响应率排行榜
export function getDidiResponseRankingList(pageIndex,pageSize) {
  return request({
    url: '/api/tutordata/GetDidiResponseRankingList?pageIndex='+pageIndex+"&pageSize="+pageSize,
    method: 'post'
  })
}

// 老师情绪分排行榜
export function getCourseFeelRankingList(pageIndex,pageSize) {
  return request({
    url: '/api/tutordata/GetCourseFeelRankingList?pageIndex='+pageIndex+"&pageSize="+pageSize,
    method: 'post'
  })
}


// 总排行榜
export function getConversionOverallLeaderboard (pageIndex,pageSize) {
  return request({
    url: '/api/tutordata/GetConversionOverallLeaderboard?pageIndex='+pageIndex+"&pageSize="+pageSize,
    method: 'post'
  })
}
// 进步排行榜
export function getConversionProgressLeaderboard () {
  return request({
    url: '/api/tutordata/GetConversionProgressLeaderboard',
    method: 'post'
  })
}
// 唤起AClassroom
export function JoinAClassRoomTraining () {
  return request({
    url: '/api/training/JoinAClassRoom',
    method: 'post'
  })
}

// 培训中心
export function learnSubmit (TrakitId,UsedTime,IsCompleteCourse) {
  return request({
    url: '/api/TutorData/LearnSubmit?TrakitId='+TrakitId+"&UsedTime="+UsedTime+"&IsCompleteCourse="+IsCompleteCourse,

    method: 'post'
  })
}
// 
export function testSubmit (data,kctId,startTime,IsCompleteCourse) {
  return request({
    url: '/api/TutorData/TestSubmit?kctId='+kctId+"&startTime="+startTime+"&IsCompleteCourse="+IsCompleteCourse,
    method: 'post',
    data
  })
}
// 
export function getTestScore (recodeId) {
  return request({
    url: '/api/TutorData/GetTestScore?recodeId='+recodeId,
    method: 'post'
  })
}
// 是否需要加上可教类别标签
export function addTutorLabel (kctId) {
  return request({
    url: '/api/TutorData/AddTutorLabel?kctId='+kctId,
    method: 'post'
  })
}